import ThermostatIcon from "@mui/icons-material/Thermostat"
import { ButtonBase } from "@mui/material"
import { FC, useState } from "react"
import { useTranslation } from "react-i18next"
import type { Locker } from "shared/locker"
import { TemperatureDemoDialog } from "./TemperatureDemoDialog"
import { activeTemperatureDemoDoors } from "./temperatureDemoTypes"

type Props = {
  locker: Locker
  lockerName: string
  /** Door open in the drawer, preselected in the dialog. */
  selectedDoorId?: string
}

/**
 * LOCKER-534 — "Démo température · N" in the dashboard header; opens the
 * setup dialog. The caller renders it only when the locker's demo is on.
 */
export const TemperatureDemoHeaderChip: FC<Props> = ({ locker, lockerName, selectedDoorId }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const count = Object.keys(activeTemperatureDemoDoors(locker)).length

  return (
    <>
      <ButtonBase
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
        sx={{
          height: 32,
          px: 1.5,
          borderRadius: 4,
          fontSize: 12.5,
          fontWeight: 600,
          fontFamily: "inherit",
          gap: 0.75,
          bgcolor: "rgba(35,66,133,.04)",
          color: "primary.main",
          border: "1px dashed rgba(35,66,133,.45)",
          "&.Mui-focusVisible": { outline: "3px solid #234285", outlineOffset: "2px" },
        }}
      >
        <ThermostatIcon aria-hidden sx={{ fontSize: 14 }} />
        <span>{t("temperatureDemo.headerChip", { count })}</span>
      </ButtonBase>
      {open && (
        <TemperatureDemoDialog
          open={open}
          onClose={() => setOpen(false)}
          locker={locker}
          lockerName={lockerName}
          initialDoorId={selectedDoorId}
        />
      )}
    </>
  )
}
